import { apiClient } from "./APIService";
import router from "../router";

export const getS3SignedNonAuthed = (fileName, fileType, key, isRef) => {
  fileName = fileName.split("#").join("");
  try {
    return apiClient.get(
      "/api-sign-s3-non-authed?file-name=" +
        fileName +
        "&file-type=" +
        fileType +
        "&key=" +
        key +
        "&isRef=" +
        isRef,
      {
        headers: { "x-access-token": localStorage.getItem("jwt") }
      }
    );
  } catch (error) {
    if (error.response.status == 500) {
      router.push({ name: "logout", params: {} });
    }
  }
};
